import { qs, listen, qsa } from "@fluorescent/dom";
import { on } from "@/glow/events";

const selectors = {
  quantitySelector: "[data-quantity-selector]",
  quantityInput: "[data-quantity-input]",
  addQuantity: "[data-add-quantity]",
  subtractQuantity: "[data-subtract-quantity]",
  cartItemCount: "[data-cart-item-count]",
  displayedItemCount: ".item_count",
  productItem: ".product-item",
  variantIdInput: "[data-variant-id-input]",
};

export default function (container) {
  const quantityWrappers = qsa(selectors.quantitySelector, container);
  if (!quantityWrappers || quantityWrappers.length === 0) return;
  const events = [];
  const inputs = [];

  const updateAllInputs = val => {
    inputs.forEach(input => (input.value = val));
  };

  const handleInputChange = e => {
    updateAllInputs(e.target.value);
  };

  const handleAddQuantity = quantityInput => {
    const currentValue = parseInt(quantityInput.value, 10);
    const newValue = currentValue + 1;

    updateAllInputs(newValue);
    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleSubtractQuantity = quantityInput => {
    const currentValue = parseInt(quantityInput.value, 10);

    if (currentValue === 1) return;

    const newValue = currentValue - 1;
    updateAllInputs(newValue);
    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleCartItemCount = (cartItemCount, quantity) => {
    const displayedItemCount = qs(selectors.displayedItemCount, cartItemCount);

    cartItemCount.dataset.cartItemCount = quantity;
    displayedItemCount.textContent = quantity;
  };

  // check for multiple instances of quantity-input, e.g. product block or optional input in product form
  quantityWrappers.forEach(el => {
    const quantityIsForProductCard = el.closest(selectors.productItem);
    // Product blocks can contain product cards that are not associated with the template product.
    if (quantityIsForProductCard) return;

    const quantityInput = qs(selectors.quantityInput, el);
    const addQuantity = qs(selectors.addQuantity, el);
    const subtractQuantity = qs(selectors.subtractQuantity, el);
    const cartItemCount = qs(
      selectors.cartItemCount,
      el.previousElementSibling
    );

    // track all input instances to update all on change
    inputs.push(quantityInput);
    events.push(
      listen(addQuantity, "click", () => handleAddQuantity(quantityInput)),
      listen(subtractQuantity, "click", () =>
        handleSubtractQuantity(quantityInput)
      ),
      listen(quantityInput, "change", handleInputChange)
    );

    if (cartItemCount) {
      events.push(
        on(
          "theme-internal:update-quantity-selector-counts",
          ({ id, quantity }) => {
            // The hidden id input is the source of truth — Liquid renders it
            // with current_variant.id and product.js updates it on every swap.
            const currentId = parseInt(
              qs(selectors.variantIdInput, container)?.value,
              10
            );
            if (currentId === id) {
              handleCartItemCount(cartItemCount, quantity);
            }
          }
        )
      );
    }
  });

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
